<template>
  <div>
    <div class="cancellation_subscription">
      <h3 class="text">
        {{ $t('subscription_details.bundles.cancellation.text', 'Cancel the subscription') }}
      </h3>

      <p class="tips" v-if="subscriptionDetails.shippingConfirmed === false">
        {{ $t('subscription_details.bundles.cancellation.content1', 'Your order is almost ready to ship and cannot be canceled through your online account at this time. Please contact our customer service who are happy to help. Contact details available at the Support section') }}
      </p>

      <p class="tips" v-if="subscriptionDetails.shippingConfirmed === true">
        {{ $t('subscription_details.bundles.cancellation.content', 'Sorry to see you go already... ... by clicking the button below') }}
      </p>

      <app-button
      v-if="subscriptionDetails.shippingConfirmed === true"
        type="submit"
        class="cancelProcess"
        @click.prevent="openModalStep2"
      >
        {{ $t('subscription_details.bundles.cancellation.button.process', "Process") }}
      </app-button>
      <div class="cancellation_subscription_reasons">
        <app-modal name="step2" @after-closed="emptyCancelData">
          <div class="v--modal-content">
            <h3 class="modal-title">
            </h3>
            <div class="modal-content">
              <div class="CancleSubscription_ReasonForm">
                <h4>
                  {{ $t('subscription_details.accordion.cancel.form.reason', 'Reason for cancelling') }}
                </h4>

                <div class="CheckboxGroup">
                  <app-checkbox
                    v-for="(item, index) in cancelReason"
                    :key="index"
                    :id="'reason' + (index + 1)"
                    :label="item.text"
                    :value="item.checked"
                    @input="item.checked = $event"
                  />
                </div>

                <app-textarea
                  :placeholder="$t('subscription_details.accordion.cancel.form.textarea', 'Please tell us more')"
                  v-model.trim="cancelMoreInfo"
                  maxlength="200"
                />

                <div class="modal-button-warpper">
                  <app-button
                    @click="closeModalStep2"
                    :disabled="!cancelReasonSelected && !cancelMoreInfo"
                    class="cancel_closeModal"
                  >
                    {{ $t('subscription_details.accordion.cancel.onlyReplenishment.button.cancel', 'Cancel') }}
                  </app-button>

                  <app-button
                    @click.prevent="cancellationSubscriptionTask.run()"
                    :disabled="!cancelReasonSelected && !cancelMoreInfo"
                    :is-loading="cancellationSubscriptionTask.isActive"
                    class="cancel_openModal"
                  >
                    {{ $t('subscription_details.accordion.cancel.onlyReplenishment.button.proceed', 'Proceed') }}
                  </app-button>
                </div>
              </div>
            </div>
          </div>
        </app-modal>
      </div>
      <app-modal name="newFlowForCancelReplenishment" @after-closed="emptyCancelData" width="500px">
        <div class="v--modal-content">
          <h3 class="modal-title">
          </h3>
          <div class="modal-content">
            <div class="newFlowForCancelReplenishment_popUp">
              <h4>
                {{ $t('subscription_details.cancellation.popUp.tips', "We are sorry to hear that you want to cancel your subscription.") }}
              </h4>

              <h4 v-if="subscriptionDetails.ableToPauseReplenishment && displayModifyButton">
                {{ $t('subscription_details.cancellation.popUp.pauseOrModify.subTips', "Did you know you can also pause your subscription? Or modify your subscription to a different plan?") }}
              </h4>

              <h4 v-if="subscriptionDetails.ableToPauseReplenishment && !displayModifyButton && !subscriptionDetails.isBCBSSubscription ">
                {{ $t('subscription_details.cancellation.popUp.pause.subTips', "Did you know you can also pause your subscription?") }}
              </h4>

              <h4 v-if="!subscriptionDetails.ableToPauseReplenishment && displayModifyButton">
                {{ $t('subscription_details.cancellation.popUp.modify.subTips', "Did you know you can also modify your subscription to a different plan?") }}
              </h4>
              <div class="modal-button-warpper">
                <app-button
                  class="cancel_closeModal"
                  v-if="subscriptionDetails.ableToPauseReplenishment && subscriptionDetails.isBCBSSubscription === false"
                  @click.prevent="pauseReplenishment"
                >
                  {{ $t('subscription_details.cancellation.popUp.button.pause', "Pause") }}
                </app-button>
                <app-button
                  class="cancel_closeModal"
                  v-if="displayModifyButton && subscriptionDetails.isBCBSSubscription === false"
                  @click.prevent="modifySubscription"
                >
                  {{ $t('subscription_details.cancellation.popUp.button.modify', "Modify") }}
                </app-button>

                <app-button
                  class="cancel_openModal"
                  @click.prevent="cancelSubscription"
                >
                  {{ $t('subscription_details.cancellation.popUp.button.cancel', "Cancel") }}
                </app-button>
              </div>
            </div>
          </div>
        </div>
      </app-modal>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { cloneDeep } from 'lodash'
  import Vue from 'vue'
  import { extractErrorMessage } from '@/utilities/common'
  import { detectedCulture } from 'utilities/common/culture'
  export default {
    name: 'cancellation-subscription',

    data () {
      return {
        cancelReason: [],
        cancelMoreInfo: '',
        currentCountryCode: detectedCulture.countryCode
      }
    },

    props: {
      onlyDevice: {
        type: [Object, Boolean],
        default: null
      },
      displayModifyButton: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      ...mapState('subscription', ['subscriptionDetails']),

      initialCancelReason () {
        return this.subscriptionDetails.cancelReasonOptions.map(item => ({
          text: item,
          checked: false
        }))
      },

      cancelReasonSelected () {
        let cancelReasonSelected = ''
        this.cancelReason.find(item => {
          if (item.checked) {
            cancelReasonSelected = cancelReasonSelected + item.text + ';'
          }
        })
        return cancelReasonSelected.substring(0, cancelReasonSelected.length - 1)
      }
    },

    methods: {
      emptyCancelData () {
        this.cancelReason = cloneDeep(this.initialCancelReason)
        this.cancelMoreInfo = ''
      },

      closeModalStep2 () {
        this.$bus.$emit('close-modal', 'step2')
        this.cancelReason = cloneDeep(this.initialCancelReason)
        this.cancelMoreInfo = ''
      },

      openModalStep2 () {
        if (!this.onlyDevice && (this.subscriptionDetails.ableToPauseReplenishment || this.displayModifyButton)) {
          this.$bus.$emit('open-modal', 'newFlowForCancelReplenishment')
        } else {
          this.$bus.$emit('open-modal', 'step2')
        }
      },

      pauseReplenishment () {
        this.$bus.$emit('open-modal', 'replenishmentPause')
        this.$bus.$emit('close-modal', 'newFlowForCancelReplenishment')
      },

      modifySubscription () {
        if (this.displayModifyButton) {
          this.$scrollTo('[data-scroll="modifyAccordion"]', {
            offset: -400
          })
          this.$bus.$emit('close-modal', 'newFlowForCancelReplenishment')
          this.$bus.$emit('expend-modify-accordion')
        }
      },

      cancelSubscription () {
        this.$bus.$emit('open-modal', 'step2')
        this.$bus.$emit('close-modal', 'newFlowForCancelReplenishment')
      }
    },

    tasks (t) {
      return {
        cancellationSubscriptionTask: t(async function () {
          if (this.subscriptionDetails.isBCBSSubscription === true){
            await Vue.api.subscription.bcbscancellation(this.subscriptionDetails.number,this.cancelReasonSelected, this.cancelMoreInfo)
          } else {
            await Vue.api.subscription.cancellationSubscription(this.subscriptionDetails.number, this.cancelReasonSelected, this.cancelMoreInfo)
          }
          this.$router.replace({
            name: 'my-account'
          })
        }).onError(function (task) {
          this.$notify({
            type: 'error',
            title: extractErrorMessage(task.error)
          })
        })
      }
    },

    created () {
      this.cancelReason = cloneDeep(this.initialCancelReason)
    }
  }
</script>

<style lang="scss">
  .selectReturnOrCancel {
    .v--modal-content {
      .subTips {
        line-height: .24rem;
        letter-spacing: .002rem;
        color: #212121;
        font-size: .16rem;
        margin: .06rem 0 .32rem;
      }
    }
  }

  .cancelProcess {
    width: auto;
    margin-top: .24rem;

    @include media(tablet) {
      min-width: 30%;
    }
  }

  .cancellation_subscription_reasons {
    .v--modal-box {
      .v--modal-container {
        .v--modal-content {
          .modal-content {
            .CancleSubscription_ReasonForm {
              .updateAddressButton {
                justify-content: flex-start;
              }

              border: none;

              .CheckboxGroup {
                .Form_group {
                  .Form_label {
                    color: #000;
                  }

                  .AppCheckbox_label {
                    border-color: #000;
                  }
                }
              }
            }

            .modal-button-warpper {
              margin-top: .3rem;
              justify-content: flex-end !important;

              .cancel_closeModal {
                background-color: white;
                color: $blue;
                margin-right: .32rem;
                width: auto;

                &:disabled {
                  color: white;
                }
              }

              .cancel_openModal {
                width: auto !important;
                padding: .08rem .4rem;
              }

              .AppButton {
                width: auto !important;
              }
            }
          }
        }
      }
    }
  }

  .newFlowForCancelReplenishment_popUp {
    .modal-button-warpper {
      .AppButton {
        margin-right: .2rem;
      }

      .AppButton:nth-last-child(1) {
        margin-right: 0;
      }

      .cancel_openModal {
        // width: auto !important;
        padding: .08rem .15rem !important;
      }
    }
  }
</style>
